import React from "react";
import Date from "../components/Date";

// update log
// FB 4371 DK    03/29/2021    Added to invoke the date component

export default function ByDatePage(data:any) {
  return <Date  {...data}/>;
}
